import Builder from '../../utils/redux/builder';
import { upperFirstLetter } from '../../utils/helpers/helpers';

const convertRequestTypeToCamelCase = (input) => {
  return input
    .split('/')
    .slice(0, -1)
    .map((part) =>
      part
        .split('-')
        .map((word, index) => (!index ? word : upperFirstLetter(word)))
        .join(''),
    )
    .map((part, index) => (!index ? part : upperFirstLetter(part)))
    .join('');
};

const builder = new Builder({
  name: 'requestsHandler',
  initialState: {},
  reducers: {
    setSettled: (state, { payload: requestName }) => {
      state[requestName].status = 'settled';
    },
    setClosed: (state, { payload: requestName }) => {
      state[requestName].status = 'closed';
    },
  },
}).addMatcher(
  ({ type }) => ['requests/', '/user'].some((path) => type.startsWith(path)),
  (state, { meta, payload, type }) => {
    if (!meta) return;
    const { requestStatus } = meta;
    const requestName = convertRequestTypeToCamelCase(type);
    state[requestName] = { status: requestStatus, data: payload, meta };
  },
);

export const requestsHandler = builder.create().export();

export const { useRequestsHandler } = requestsHandler.selectors;
export const { setSettled, setClosed } = requestsHandler.actions;

export default requestsHandler;
